package com.nonopn.skydome.common.app.pages.probes

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier

import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.navigation.RouterProjects
import com.nonopn.skydome.common.app.pages.account.AccountModel
import com.nonopn.skydome.common.app.pages.account.SondesTab
import com.nonopn.skywatcher.design.theme.AppColor

import eu.codlab.viewmodel.rememberViewModel

// Dedicated entry point for the "Mes sondes" nav section.
// Delegates to SondesTab which holds all probe card UI.
@Composable
fun ProbesScreen(modifier: Modifier = Modifier) {
    val appModel: AppModel = LocalApp.current
    val model = rememberViewModel { AccountModel(appModel) }
    val state by model.states.collectAsState()
    // New probe creation (trial / Stripe): hidden until the backend is ready, visible for administrators
    val creationVisible = rememberProbeCreationVisible(appModel)

    // Probe requested by the dashboard map pop-up
    LaunchedEffect(Unit) {
        appModel.pendingProbeUuid?.let {
            model.selectProbe(it)
            appModel.pendingProbeUuid = null
        }
    }

    Column(
        modifier = modifier
            .fillMaxSize()
            .background(AppColor.StrikeBackground)
    ) {
        SondesTab(
            state = state,
            model = model,
            // Legacy admin entry to the estimate creation removed: probe creation replaces it
            onNewProbe = null,
            onCreateProbes = { openProbeCreation(appModel, trial = false) }.takeIf { creationVisible },
            onSelectProbe = { model.selectProbe(it) },
            onNavigateToProjects = { uuid ->
                if (uuid != null) appModel.pendingHighlightProjectUuid = uuid
                appModel.show(RouterProjects.navigateTo())
            }
        )
    }
}
